import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableControleCreatePage = withAsyncLoading(async () =>
    import('./ControleCreatePage').then((res) => res.ControleCreatePage)
);

export { LoadableControleCreatePage };
